
import { servicesImages } from '../../../utils/images';

export default function CommitmentSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-light text-gray-900 leading-tight mb-6">
                Our Commitment
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed font-light">
                At Musheng, fashion should be both innovative and responsible. From material sourcing to garment production, we ensure that every step of our supply chain meets international standards of sustainability, ethics, and quality.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-8 pt-8">
              <div className="text-center">
                <div className="text-3xl font-light text-green-600 mb-2">100%</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide font-light">Ethical Sourcing</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-light text-green-600 mb-2">50%</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide font-light">Waste Reduction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-light text-green-600 mb-2">7+</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide font-light">Certifications</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img
              src={servicesImages.leather}
              alt="Sustainable Manufacturing Process"
              className="w-full h-96 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
